// extracted by mini-css-extract-plugin
export default {"legacyPadding":"GeneratorModal_legacyPadding__U5w2-"};